export const publicationStatuses = {
  UNPUBLISHED: 'unpublished',
  WAITING_FOR_APPROVAL: 'waitingForApproval',
  PUBLISHED: 'published'
};
export const backendPublicationStatuses = {
  unpublished: 'UNPUBLISHED',
  waitingForApproval: 'WAITING_FOR_APPROVAL',
  published: 'PUBLISHED'
};